module.exports = __webpack_public_path__ + "img/ch3.cb3f1bd7.jpg";